import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild, inject } from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {finalize, first} from 'rxjs/operators';

import {HeaderSort, TableComponent} from '@shared';

import {Patient, PatientService} from 'planner-shared';
import {SortState} from "../../../../_shared/table/header-sort/models/enums/sort-state.enum";

@UntilDestroy()
@Component({
    selector: 'app-patients',
    templateUrl: './patients.component.html',
    styleUrls: ['./patients.component.scss'],
    standalone: false
})
export class PatientsComponent implements OnInit, OnDestroy {
    private readonly patientService = inject(PatientService);

    public loading: boolean;
    public patients: Patient[];
    public totalPatients: number;

    @Output() selectPatient = new EventEmitter<Patient>();

    @ViewChild(TableComponent, { static: true }) private readonly tableComponent: TableComponent;
    private sortValue: HeaderSort;
    private searchPhrase: string;

    private readonly InitSortBy = 'status';

    constructor() {
        this.totalPatients = 0;
    }

    ngOnInit(): void {
        this.patientService.getPatients().subscribe(patients => (this.totalPatients = patients.length));

        this.tableComponent.headerSortService
            .getHeaderSort()
            .pipe(untilDestroyed(this))
            .subscribe(sortValue => {
                this.sortValue = sortValue;
                this.loadPatients();
            });

        this.tableComponent.headerSortService
            .setHeaderSort(this.InitSortBy, false,null,null, SortState.DESCDENDING_STATE );

    }

    ngOnDestroy(): void {
        this.patientService.deselectPatient();
    }

    public searchTextChange(searchPhrase: string): void {
        this.searchPhrase = searchPhrase;
        this.patientService.deselectPatient();
        this.loadPatients();
    }

    public select(patient: Patient, event: Event): void {
        event.stopPropagation();
        event.preventDefault();
        if (!patient.selected) {
            this.patientService.deselectPatient();
            patient.selected = true;
            this.selectPatient.emit(patient);
        }
    }

    public resortPatients(): void {
        this.patientService.sortPatients(this.patients, this.sortValue);
    }

    private loadPatients(): void {
        this.loading = true;
        this.patientService
            .getPatients(this.sortValue, this.searchPhrase, true)
            .pipe(
                first(),
                finalize(() => setTimeout(() => (this.loading = false)))
            )
            .subscribe(patients => {
                this.patients = patients;
                this.selectFirstPatient();
            });
    }

    private selectFirstPatient(): void {
        if (this.patients?.length > 0) {
            const selectedPatient = this.patients.find(patient => patient.selected);
            if (!selectedPatient) {
                this.patients[0].selected = true;
            }

            this.selectPatient.emit(selectedPatient ?? this.patients[0]);
        } else {
            this.selectPatient.emit(null);
        }
    }
}
